import React from 'react';
import { Box } from '@mui/material';
import { mvkgTokens } from '../../theme/mvkgTokens';

const SIZES = { xs: 24, sm: 32, md: 40, lg: 56 };
const FONT = { xs: '0.625rem', sm: '0.75rem', md: '0.875rem', lg: '1rem' };

/** Gradient initials avatar with optional online dot + white ring. */
export default function AppAvatar({ initials, size = 'md', online = false, ring = false, sx = {} }) {
  const dim = SIZES[size] || SIZES.md;
  const dot = Math.max(8, Math.round(dim * 0.22));
  return (
    <Box sx={{ position: 'relative', flexShrink: 0, width: dim, height: dim, ...sx }}>
      <Box
        sx={{
          width: dim,
          height: dim,
          borderRadius: `${Math.round(dim * 0.3)}px`,
          background: 'linear-gradient(135deg, #6366f1 0%, #9333ea 100%)',
          color: '#fff',
          fontWeight: 700,
          fontSize: FONT[size] || FONT.md,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: ring ? '0 0 0 4px #fff' : mvkgTokens.shadow.card,
        }}
      >
        {initials}
      </Box>
      {online && (
        <Box
          sx={{
            position: 'absolute',
            bottom: -2,
            right: -2,
            width: dot,
            height: dot,
            borderRadius: '50%',
            bgcolor: '#10b981',
            border: '2px solid #fff',
          }}
        />
      )}
    </Box>
  );
}
